import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { PagedResultDto } from '../models/paged-result.dto';
import { TaskNotification } from './signalr.service';
import { AuthConfig, AUTH_CONFIG } from '../features/auth';

export interface GetNotificationsInput {
  skipCount?: number;
  maxResultCount?: number;
  sorting?: string;
  filter?: NotificationType;
}
export enum NotificationType {
  Transactions = 0,
  Wallets = 1,
  Details = 2,
  Unread = 3,
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private http = inject(HttpClient);

  private readonly cfg = inject<AuthConfig>(AUTH_CONFIG);
  private apiUrl = `${this.cfg.baseUrl}/api/Notification`;

  // service
  getAllNotifications(input: GetNotificationsInput = {}): Observable<PagedResultDto<TaskNotification>> {
    let params = new HttpParams();

    if (input.skipCount !== undefined) {
      params = params.set('skipCount', String(input.skipCount));
    }
    if (input.maxResultCount !== undefined) {
      params = params.set('maxResultCount', String(input.maxResultCount));
    }
    if (input.sorting) {
      params = params.set('sorting', input.sorting);
    }
    if (input.filter !== undefined) {
      params = params.set('filter', String(input.filter));
    }

    return this.http.get<PagedResultDto<TaskNotification>>(`${this.apiUrl}/my-notifications`, { params }).pipe(
      map((result) => ({
        ...result,
        items: result.items.map((notification) => ({
          ...notification,
          timestamp: new Date(notification.timestamp as any),
        })),
      })),
    );
  }

  markAsRead(notificationId: string): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${notificationId}/mark-as-read`, {});
  }
  markAllAsRead(filter?: NotificationType): Observable<void> {
    let params = new HttpParams();
    if (filter !== undefined) {
      params = params.set('filter', String(filter));
    }
    return this.http.put<void>(`${this.apiUrl}/mark-all-as-read`, {}, { params });
  }
}
